const RELATED_SCREENS = {
  '/my-expense': ['/expense-creation', '/other-expense', '/my-expense-details'],
  '/upload-bills': ['/camera', '/capture-image', '/captured-image-details', '/crop-image'],
  '/LeaveModule': ['/LeaveApproval'],
  '/expense-approval': ['/expense-details']
};

export const getScreenPermission = () => {
  let userData = JSON.parse(localStorage.getItem('userData'));
  const screenPermissions = userData?.screenPermissions ?? [];

  const permissions = {};

  screenPermissions.forEach(({ screenName, isAllowed }) => {
    permissions[screenName] = isAllowed === true;
  });
  Object.entries(RELATED_SCREENS).forEach(([parent, children]) => {
    if (permissions[parent] === true) {
      children.forEach((child) => {
        permissions[child] = true;
      });
    }
  });

  return permissions;
};
